export const DNS_SETUP_APIS = {
  GET_DNS_RECORDS: (domainUuid) => `host/get/custom/dnsrecords/${domainUuid}`,
  ADD_DNS_RECORD: "host/add/custom/dnsrecords",
  UPDATE_DNS_RECORD: "host/update/custom/dnsrecords",
  DELETE_RECORD: "host/delete/custom/dnsrecords",
};

export const DNS_RECORD_TYPES = {
  EMPTY: 0,
  A: 1,
  CNAME: 2,
  MX: 3,
  TXT: 4,
  AAAA: 5,
  SRV: 6,
};

export const DNS_RECORD_FORM_KEYS = {
  DOMAIN: "domain",
  MX_RECORDS: "mx_records",
  TXT_RECORDS: "txt_records",
  SRV_RECORD: "srv_records",
  CNAME_RECORD: "cname_records",
  A_RECORD: "a_records",
  AAAA_RECORD: "aaaa_records",
};

export const DNS_RECORD_KEYS = {
  uuid: "uuid",
  name: "name",
  priority: "priority",
  content: "content",
  record_id: "record_id",
  target: "target",
  port: "port",
  weight: "weight",
  ipv6: "ipv6",
};

export const DNS_RECORD_TYPE_VALUES = {
  TXT: "TXT",
  MX: "MX",
  SRV: "SRV",
  CNAME: "CNAME",
  A: "A",
  AAAA: "AAAA",
};

export const columnHeaders = {
  TYPE: "Type",
  NAME: "Name",
  CONTENT: "Content",
  ACTIONS: "Actions",
};

export const columnFields = {
  TYPE: "type",
  NAME: "name",
  CONTENT: "content",
  ACTIONS: "action",
};
